import React, { useEffect } from "react";
//import Scss
import "./assets/scss/themes.scss";
import "./App.css";
import { useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//imoprt Route
import Route from "./Routes";

const logoutIfTokenExpire = () => {
  const expirationTime = localStorage.getItem("expiryAt");
  if (expirationTime) {
    const currentTime = new Date().getTime();
    if (currentTime > parseInt(expirationTime, 10)) {
      localStorage.removeItem("authUser");
      localStorage.removeItem("expiryAt");
      localStorage.removeItem("expiryIn");
      window.location.replace("/dashboard");
    }
  }
};

function App() {
  const location = useLocation();

  // Call the token expiration check function on every route change
  useEffect(() => {
    logoutIfTokenExpire();
  }, [location]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Route />
    </React.Fragment>
  );
}

export default App;
